module.exports = __webpack_public_path__ + "static/media/map_close_directions_icon.726bc9d0.svg";